import { APPLICATION_WIDGET_PAGE_E } from "@Client/@Types/application-widget/types";
import { defineComponent, ref } from "@vue/composition-api";
import ApplicationStandalone from "@Client/@Modules/application-standalone/components/application-standalone.vue";
import { EmptyApplication } from "@Shared/@DataFiles/empty-application";
import { useAccountStoreState } from "@Client/@Modules/main/store/account/account-helpers";
import ApplicationNavbar from "@Client/@Modules/application-standalone/components/application-navbar.vue";
import ApplicationQuickActions from "@Client/@Modules/application/components/application-quick-actions.vue";
import LockedApplicationBanner from "@Client/@Modules/banners/locked-application-banner.vue";
export default defineComponent({
  name: "ApplicationWidgetContainer",
  components: {
    ApplicationStandalone,
    ApplicationNavbar,
    ApplicationQuickActions,
    LockedApplicationBanner
  },
  props: {
    page: {
      type: String,
      default: APPLICATION_WIDGET_PAGE_E.APPLICATION
    }
  },
  setup() {
    const {
      selectedApplicationId
    } = useAccountStoreState(["selectedApplicationId"]);
    const currentStep = ref("");
    const applicationStandalone = ref();
    const invalidSteps = ref([]);
    const goNext = () => applicationStandalone.value.goNext();
    const goPrev = () => applicationStandalone.value.goPrev();
    const goEdit = page => applicationStandalone.value.goEdit(page);
    const handleInvalidStep = ({
      invalidPages
    }) => {
      invalidSteps.value = invalidPages;
    };
    return {
      applicationId: selectedApplicationId,
      application: EmptyApplication(),
      currentStep,
      applicationStandalone,
      invalidSteps,
      goNext,
      goPrev,
      goEdit,
      handleInvalidStep
    };
  }
});